import React from 'react';
import {Link} from 'react-router-dom';

export const CONTENT = '/content';
export const CONTENT_ONE = '/content-one';
export const EMBED = '/embed';
export const GETLINK = '/getlink';
export const TASKS_LIST = '/tasks-list';
export const TASKS_CREATE = '/tasks-create';
export const TASKS_VIEW = '/tasks-view';
export const HOME = '/';

interface PropsType{
	isLoggedIn:boolean
}

const Navigation: React.FC<PropsType> = (props) => {
	return(
		<div id='teachers-navigation'>
			<Link to={CONTENT}><button className='teachers-button teachers-button-default'>Content Sets</button></Link>

			<Link to={TASKS_LIST}>
				<button className='teachers-button teachers-button-default'
					disabled={!props.isLoggedIn}
					>Homework Tasks</button>
			</Link>

			<Link to={EMBED}><button className='teachers-button teachers-button-default'>Embed</button></Link>
			<Link to={GETLINK}><button className='teachers-button teachers-button-default'>Links</button></Link>
		</div>
	)
};

export default Navigation;

